import {Permissions} from '@/core/config/enums/Permissions'
import { Paths,Names } from '@/core/config/enums/SitePaths';
const ClientMenuConfig = [
  {
      heading: "DASHBOARD",
    
      route: "/",
      pages: [
          {
          heading: "Dashboard",
          route: Paths.DASHBOARD,
          svgIcon: "/media/icons/duotune/ecommerce/ecm001.svg",
          fontIcon: "bi-layers",                  
        },
        {
          heading: "Commissions",
          route: Paths.CLIENT_COMMISSIONS,
          svgIcon: "/media/icons/duotune/finance/fin006.svg",
          fontIcon: "bi-printer",
        },
        {
          heading: "Rooms",
          route: Paths.ROOMS_CLIENTS,
          svgIcon: "/media/icons/duotune/finance/fin006.svg",
          fontIcon: "bi-printer",
          
        },
        
      ]
  },  
  
];

export default ClientMenuConfig;
